(function($) {
  "use strict";
  $(function() {
    $(".js-match-height").matchHeight({
      byRow: true,
    });
  });
})(jQuery);
